import { exists } from '@/api'

export interface SimpleAcceptCollection {
  collectionId: number
  orderId: number
  collectionNo: string
  displayTitle: string
  sortTitle: string
  shelfType: string
  collectionType: string
  handlingType: string
  hasReserve: boolean
  revision: number
  mark: string
  ndc: string
  book: string
  sub: string
}

export const defaultSimpleAcceptCollection = (): SimpleAcceptCollection => ({
  collectionId: 0,
  orderId: 0,
  collectionNo: '',
  displayTitle: '',
  sortTitle: '',
  shelfType: '',
  collectionType: '',
  handlingType: '',
  hasReserve: false,
  revision: 0,
  mark: '',
  ndc: '',
  book: '',
  sub: ''
})

export function SimpleAcceptCollectionFromJSON(
  json: any
): SimpleAcceptCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    orderId: exists(json, 'order_id') ? json.order_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    shelfType: exists(json, 'shelf_type') ? json.shelf_type : '',
    collectionType: exists(json, 'collection_type') ? json.collection_type : '',
    handlingType: exists(json, 'handling_type') ? json.handling_type : '',
    hasReserve: exists(json, 'has_reserve') ? json.has_reserve : false,
    revision: exists(json, 'revision') ? json.revision : 0,
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : ''
  }
}
